<template>
  <div class="bordered border-1 border-2 border-light p-2 rounded">
    <div class="d-flex justify-content-between">
      <div>
        <div
          class="font-weight-bold"
        >
          {{ cardTitle }}
        </div>
        <div class="font-medium-2 font-weight-bolder">
          {{ cardAmount | toCurrency }} TL
        </div>
      </div>
      <div
        :class="'bg-light-' + cardColor"
        class="width-50 height-50 rounded-circle d-flex justify-content-center align-items-center"
      >
        <FeatherIcon
          :icon="cardIcon"
          size="18"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TotalCard',
  props: {
    cardTitle: {
      type: String,
      required: true,
    },
    cardColor: {
      type: String,
      required: true,
    },
    cardIcon: {
      type: String,
      required: true,
    },
    cardAmount: {
      type: Number,
      required: true,
    },
  },
}
</script>
